import React from 'react';
import { ChevronDown } from 'lucide-react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility for merging tailwind classes properly
 */
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const Select = React.forwardRef(({ 
  className, 
  error, 
  label, 
  hint, 
  icon: Icon,
  options = [],
  children,
  ...props 
}, ref) => {
  return (
    <div className="space-y-2 w-full group">
       {label && (
         <label
           className="text-[11px] font-semibold transition-colors"
           style={{
             color: error ? '#BA0517' : 'var(--color-text-main)'
           }}
         >
           {label}
         </label>
       )}

       <div className="relative">
          {Icon && (
            <div
              className="absolute left-3 top-1/2 -translate-y-1/2 transition-colors pointer-events-none"
              style={{
                color: error ? '#BA0517' : 'var(--color-text-dim)'
              }}
            >
               <Icon size={18} />
            </div>
          )}

          <select
            ref={ref}
            className={cn(
              "w-full h-9 rounded-[var(--radius-slds)] px-3 text-[13px] font-normal appearance-none cursor-pointer outline-none transition-all duration-150",
              className
            )}
            style={{
              backgroundColor: 'var(--color-brand-card)',
              borderColor: error ? '#BA0517' : '#D8DDE6',
              color: 'var(--color-text-main)',
              borderWidth: '1px',
              borderStyle: 'solid',
              paddingLeft: Icon ? '2.5rem' : '0.75rem',
              paddingRight: '2rem',
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237f8085' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 0.75rem center'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#0176D3';
              e.target.style.boxShadow = '0 0 0 3px rgba(1, 118, 211, 0.08)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = error ? '#BA0517' : '#D8DDE6';
              e.target.style.boxShadow = 'none';
            }}
            {...props}
          >
            {children || options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
       </div>

       {error && (
         <div className="text-[11px] font-medium ml-0.5 animate-in slide-in-from-top-1" style={{ color: '#BA0517' }}>
            {error}
         </div>
       )}
       {hint && !error && (
         <div className="text-[11px] font-medium ml-0.5" style={{ color: 'var(--color-text-muted)' }}>
            {hint}
         </div>
       )}
    </div>
  );
});

Select.displayName = 'Select';

export default Select;

export { Select };
